import * as React from "react";

function SecondaryButton() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="21" viewBox="0 0 76 21">
    <g id="Primary_Button" data-name="Primary Button" transform="translate(20 7)">
      <g id="Rectangle_8874" data-name="Rectangle 8874" transform="translate(-20 -7)" fill="#fff" stroke="#2067ed" strokeWidth="1">
        <rect width="76" height="21" rx="2" stroke="none"/>
        <rect x="0.5" y="0.5" width="75" height="20" rx="1.5" fill="none"/>
      </g>
      <text id="Secondary_Button" data-name="Secondary Button" transform="translate(-12 6)" fill="#2067ed" font-size="7" font-family="OpenSans-Semibold, Open Sans" font-weight="600"><tspan x="0" y="0">Secondary Button</tspan></text>
    </g>
  </svg>
  

  );
}

export default SecondaryButton;
